<button
	type="button"
	class="tooth-button"
	[attr.data-testid]="'art-tooth-' + tooth.toothId"
	[attr.aria-pressed]="tooth.isSelected"
	[disabled]="chartReadOnly || isToothDisabled"
	(click)="onToothClick()"
	[attr.aria-label]="'TeethDiagram.ToothAlt' | translate: { number: displayNumber }"
>
	<span *ngIf="numberPosition === 'above'" class="tooth-number">{{ displayNumber }}</span>
	<svg class="tooth-image" aria-hidden="true"><use [attr.href]="'#' + symbolId" /></svg>
	<span *ngIf="numberPosition === 'below'" class="tooth-number">{{ displayNumber }}</span>
</button>
<div *ngIf="hasMultipleTreatments" class="tooth__treatment-indicators" aria-hidden="true">
	<span
		*ngFor="let treatment of treatmentClassNames"
		[ngClass]="['tooth__treatment-indicator', 'tooth__treatment-indicator--' + treatment]"
	></span>
</div>
<div class="tooth__selection-frame"></div>
